import { Navigate, useParams } from "react-router-dom";

import { useAuth } from "../../../app/providers/AuthProvider";
import {
  canAccessStockSubsection,
  getStockSubsectionByPath,
} from "../constants/stockAreas";
import StockSubsectionPlaceholder from "../components/StockSubsectionPlaceholder";
import { getStockSubsectionPage } from "../stockSubsectionPages";

export default function StockSubsectionPage() {
  const { sectionPath, subsectionPath } = useParams();
  const { user } = useAuth();
  const { section, subsection } = getStockSubsectionByPath(
    sectionPath,
    subsectionPath
  );

  if (!section) return <Navigate to="/stock" replace />;
  if (!subsection) return <Navigate to={`/stock/${section.path}`} replace />;
  if (!canAccessStockSubsection(subsection, user)) {
    return <Navigate to={`/stock/${section.path}`} replace />;
  }

  const PageComponent = getStockSubsectionPage(sectionPath, subsectionPath);

  if (PageComponent) return <PageComponent />;

  return (
    <StockSubsectionPlaceholder
      sectionPath={sectionPath}
      subsectionPath={subsectionPath}
    />
  );
}
